<template>
  <th v-if="badge" class="table-header" :colspan="colspan" :rowspan="rowspan">
    <div class="flex">
      <span class="label"><slot></slot></span>
      <BadgeIcon class="-requires" :class="badgeSize">{{ badge }}</BadgeIcon>
    </div>
    <slot name="tooltip"></slot>
  </th>
  <th v-else class="table-header" :colspan="colspan" :rowspan="rowspan">
    <slot></slot>
    <slot name="tooltip"></slot>
  </th>
</template>

<script>
import BadgeIcon from "@/components/badges/BadgeIcon";

export default {
  name: "TableHeader",
  components: { BadgeIcon },
  props: {
    colspan: { type: String, default: "" },
    rowspan: { type: String, default: "" },
    badge: { type: String, default: "" },
    badgeSize: { type: String, default: "" },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";
@import "@/assets/stylesheets/mixins/_flex";
.table-header {
  border-collapse: collapse;
  border: 1px solid $secondary;
  background-color: $light;
  text-align: left;
  padding: 15px;
  font-weight: normal;
  position: relative;
  background-clip: padding-box;
  @include mq-down(md) {
    display: block;
    width: 100%;
    border-top: 0;
    border-left: 0;
    border-right: 0;
    &.-harfleft {
      background-color: $secondary;
    }
  }
  @include mq-up(md) {
    padding: 25px 10px 25px 25px;
    min-width: 240px;
    width: 25%;
    &.-harfleft {
      min-width: 110px;
      width: 12%;
    }
    &.-harfright {
      min-width: 130px;
      width: 13%;
    }
  }
  > .flex {
    @include flex(flex, space-between, center, row, nowrap);
    width: 100%;
    @include mq-up(md) {
      min-height: 50px;
    }
    @include mq-down(md) {
      @include flex(flex, flex-end, center, row-reverse, nowrap);
      > .label {
        margin-left: 0.7em;
      }
    }
  }
  &.-hastooltip {
    @include mq-down(md) {
      padding-right: 30px;
    }
  }
}
.table-box.-members {
  .table-body {
    .table-row {
      .table-header {
        width: 33.33%;
        @include mq-down(md) {
          display: table-cell;
          width: 44%;
          border: 1px solid $secondary;
        }
      }
    }
  }
}
.table-box.-nextusage {
  .table-body {
    .table-row {
      .table-header {
        width: 33.33%;
        @include mq-down(md) {
          display: block;
          width: 100%;
          border-top: none;
        }
      }
    }
  }
}
.table-box.-entry {
  .table-body {
    .table-row {
      .table-header {
        background-color: $success;
        @include mq-down(md) {
          &.-harfleft {
            background-color: $info;
          }
        }
      }
    }
  }
}

/* for ie11 */
@media all and (-ms-high-contrast: none) {
  *::-ms-backdrop,
  .table-header {
    vertical-align: top;
    display: table-cell;
    position: static;
  }
  *::-ms-backdrop,
  .table-header .flex {
    height: 50px;
  }
  .table-box .table-body .table-row .table-header {
    background: $light;
  }
  .table-box.-entry .table-body .table-row .table-header {
    background: $success;
  }
}
</style>
